import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import {
    ODataTimesheetAndExpensesOutModel,
    TimesheetAndExpensesP58Model,
} from '../../models/complex/timesheet-and-expenses-p58.model';
import { getUuidV4 } from '../../utilities/generic-utilities';
import { OdataService } from '../odata/odata.service';

@Injectable({
    providedIn: 'root',
})
export class OdataTimesheetService {
    public constructor(private readonly odataService: OdataService) {}

    public saveTimesheet(timesheet: TimesheetAndExpensesP58Model): Observable<unknown> {
        return this.odataService.deepInsertRequest(timesheet, ENDPOINTS.EndOfWorkSet, `${getUuidV4()}`);
    }

    /**
     * Submits an already-serialized timesheet out model. Used by the timesheet
     * store's submit effect, whose action payload carries the serializable out
     * model instead of the P58 form model.
     *
     * @param outModel the serialized timesheet and expenses out model
     * @returns the OData response
     */
    public saveTimesheetOutModel(outModel: ODataTimesheetAndExpensesOutModel): Observable<unknown> {
        return this.odataService.deepInsertOutModelRequest(outModel, ENDPOINTS.EndOfWorkSet, `${getUuidV4()}`);
    }
}
